import React from 'react';
import ClassNames from 'classnames';
import WindowListenable from 'mixins/js/WindowListeners';
import DateTime from 'utils/date-time';
import KeyCode from 'utils/key-code';
import moment from 'moment-timezone';
import DatePickerDialog from 'components/date-picker/DatePickerDialog';
import TextField from 'components/forms/text-field/TextField';
import IconButton from 'components/buttons/icon-button/IconButton';

export default React.createClass({

	mixins: [WindowListenable],

	propTypes: {
		defaultDate: React.PropTypes.object,
		formatDate: React.PropTypes.string,
		mode: React.PropTypes.oneOf(['portrait', 'landscape', 'inline']),
		onFocus: React.PropTypes.func,
		onTouchTap: React.PropTypes.func,
		onChange: React.PropTypes.func,
		onShow: React.PropTypes.func,
		onDismiss: React.PropTypes.func,
		timeOffset: React.PropTypes.array,
		maxDate: React.PropTypes.object,
		minDate: React.PropTypes.object,
		timePicker: React.PropTypes.bool,
		validateDate: React.PropTypes.bool
	},

	windowListeners: {
		'keyup': '_handleWindowKeyUp'
	},

	getDefaultProps() {
		return {
			formatDate: 'MM/DD/YYYY hh:mm:ss a Z',
			mode: 'inline',
			timePicker: true,
			validateDate: true
		};
	},

	getInitialState() {
		return {
			date: this.props.defaultDate || moment(),
			dialogDate: moment(),
			floatingLabelText: null,
		};
	},

	render() {
		let {
			formatDate,
			mode,
			onFocus,
			onTouchTap,
			onShow,
			onDismiss,
			timeOffset,
			maxDate,
			minDate,
			timePicker,
		} = this.props;

		let classes = ClassNames('lui-date-picker', {
			'lui-is-landscape': this.props.mode === 'landscape',
			'lui-is-inline': this.props.mode === 'inline'
		});

		let defaultInputValue;

		if (this.props.defaultDate) {
			defaultInputValue = this.props.defaultDate.format(this.props.formatDate);
		};


		return (
			<div className={classes}>
				<TextField
					{...this.props}
					floatingLabelText={this.state.floatingLabelText}
					onChange={this._handleOnChange}
					onBlur={this._handleOnBlur}
					ref="input"
					defaultValue={defaultInputValue}>
					<IconButton
						icon="calendar"
						tooltip="Open Date Picker"
						onClick={this._handleInputTouchTap}
						className="lui-date-picker-icon-button"/>
				</TextField>
				<DatePickerDialog
					ref="dialogWindow"
					onAccept={this._handleDialogAccept}
					onShow={onShow}
					onDismiss={onDismiss}
					timeOffset={timeOffset}
					maxDate={maxDate}
					minDate={minDate}
					timePicker={timePicker}
					mode={mode} />
			</div>

		);
	},

	getDate() {
		return this.state.date.format(this.props.formatDate);
	},

	setDate(d) {
		this.setState({
			date: d
		});
		if (this.props.timePicker){
			this.refs.input.setValue(d.format(this.props.formatDate));
		} else {
			this.refs.input.setValue(d.format('MM/DD/YYYY'))
		}

	},

	isValid() {
		let input = this.refs.input,
			inputText = input.getValue(),
			date = moment(new Date(inputText)),
			textIsValid = date.isValid();

		return textIsValid;
	},

	_handleOnBlur() {
		let input = this.refs.input,
			inputText = input.getValue(),
			date = moment(new Date(inputText));

		if (this.isValid()) {this.setDate(date)}
		if (this.props.onBlur) {this.props.onBlur()}
	},

	_handleOnChange(d) {
		if (this.props.onChange) {this.props.onChange(null, this.state.getDate())};
		if (this.props.validateDate) {this._validateDate()};
	},

	_handleDialogAccept(d) {
		this.setDate(d);
		if (this.props.onChange) {this.props.onChange(null, d)};
		if (this.props.validateDate) {this._validateDate()};

	},

	_validateDate() {

		let input = this.refs.input,
			inputText = input.getValue(),
			date = moment(new Date(inputText)),
			textIsValid = date.isValid();

		if (textIsValid){
			input.setErrorText(null);
			this.setState({
				floatingLabelText: this.props.timePicker ?
					date.format('dddd, MMMM Do YYYY, hh:mm:ss a') :
					date.format('dddd, MMMM Do YYYY')
			});

		} else {
			input.setErrorText('That Date Is Not Valid!')
			this.setState({
				floatingLabelText: null
			});
		};
	},

	_handleInputFocus(e) {
		e.target.blur();
		if (this.props.onFocus) this.props.onFocus(e);
	},

	_handleInputTouchTap(e) {
		this.setState({
			dialogDate: this.getDate()
		});

		this.refs.dialogWindow.show();
		if (this.props.onTouchTap) this.props.onTouchTap(e);
	},

	_handleWindowKeyUp(e) {
		//TO DO: open the dialog if input has focus
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/date-picker/DatePicker.js
 **/